var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "rmfarm",
            "title": "Solution",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" Smart Farm Solution ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v("The product enhances the quality and yield of crops by providing data on the water content in root zones.")];
      },
      proxy: true
    }])
  }, [_c('b', [_vm._v("Medium Water Content Measurement Device")])]), _c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "794",
      "aspect-ratio": 794 / 378,
      "src": "/images/sub/solution/smartfarm/rmfarm-img.png",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  })], 1), _c('v-container', [_c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('page-section', [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('tit-wrap-large', {
          staticClass: "tit-wrap--lg",
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v("RMFarm recognized for its innovativeness and technology RMFarm is "), _c('br', {
                staticClass: "d-none d-md-block"
              }), _vm._v("an excellent and innovative R&D product registered in the Innovation Market of the Public Procurement Service. ")];
            },
            proxy: true
          }])
        }, [_c('b', [_vm._v("RMFarm recognized for "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("its innovativeness and technology")])]), _c('v-row', {
          staticClass: "row--lg"
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade-left",
            "data-aos-delay": "100"
          }
        }, [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 374 / 298,
            "content-class": "d-flex pa-20px"
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "270",
            "aspect-ratio": 270 / 68,
            "src": "/images/sub/solution/smartfarm/rmfarm-img2.png"
          }
        })], 1)], 1), _c('div', {
          staticClass: "mt-20px mt-md-40px"
        }, [_c('tit-wrap-sprout', [_vm._v(" RMFarm Premium ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Measurement items")];
            },
            proxy: true
          }])
        }, [_vm._v(" Real-time weight, supply amount, drainage amount, drainage EC, drainage pH, medium temperature, temperature, and humidity ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Applications")];
            },
            proxy: true
          }])
        }, [_vm._v(" Greenhouse crops such as bell peppers, tomatoes, and strawberries ")])], 1)], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade-left",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 374 / 298,
            "content-class": "d-flex pa-20px"
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "304",
            "aspect-ratio": 304 / 90,
            "src": "/images/sub/solution/smartfarm/rmfarm-img3.png"
          }
        })], 1)], 1), _c('div', {
          staticClass: "mt-20px mt-md-40px"
        }, [_c('tit-wrap-sprout', [_vm._v(" RMFarm Basic ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Measurement items")];
            },
            proxy: true
          }])
        }, [_vm._v(" Real-time weight, supply amount, drainage amount, drainage EC, and drainage pH ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Applications")];
            },
            proxy: true
          }])
        }, [_vm._v(" Greenhouse crops such as bell peppers and tomatoes ")])], 1)], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade-left",
            "data-aos-delay": "300"
          }
        }, [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 374 / 298,
            "content-class": "d-flex pa-20px"
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "260",
            "aspect-ratio": 260 / 132,
            "src": "/images/sub/solution/smartfarm/rmfarm-img4.png"
          }
        })], 1)], 1), _c('div', {
          staticClass: "mt-20px mt-md-40px"
        }, [_c('tit-wrap-sprout', [_vm._v(" RMFarm Entry-level ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Measurement items")];
            },
            proxy: true
          }])
        }, [_vm._v(" Real-time weight, supply amount, and drainage amount ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Applications")];
            },
            proxy: true
          }])
        }, [_vm._v(" Medium-based greenhouse crops such as bell peppers and tomatoes ")])], 1)], 1)], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 1200 / 770,
            "content-class": "d-flex align-center justify-center"
          }
        }, [_c('div', {
          staticClass: "pa-30px pa-md-40px px-lg-80px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "800",
            "width": _vm.$vuetify.breakpoint.lgAndUp ? '800' : '',
            "aspect-ratio": 800 / 376,
            "src": "/images/sub/solution/smartfarm/rmfarm-img5.png"
          }
        }), _c('div', {
          staticClass: "pt-30px pt-md-40px pt-lg-60px"
        }, [_c('tit-wrap-small', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v("Our self-developed software provides a simple and easy user-friendly interface. "), _c('br', {
                staticClass: "d-none d-lg-block"
              }), _vm._v("You can access information via the PC, tablet, and mobile device.")];
            },
            proxy: true
          }])
        }, [_vm._v(" Easy and simple real-time monitoring via both the Internet and mobile device ")])], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/smartfarm/rmfarm-img6.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" Moisture Content Measurement Apparatus of Plants' Root Zone ")];
            },
            proxy: true
          }])
        }, [_vm._v(" Registered Patent ")])], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/smartfarm/rmfarm-img7.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" Root zone water content measurement device ")];
            },
            proxy: true
          }])
        }, [_vm._v(" Registered in the Agricultural Machinery List ")])], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "300"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/smartfarm/rmfarm-img8.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" Registered in the Innovation Market of the Public Procurement Service ")];
            },
            proxy: true
          }])
        }, [_vm._v(" Registered as an innovative product ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('v-container', [_c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('page-section', {
    staticClass: "page-section--last",
    attrs: {
      "id": "rmfarm-portfolio"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v(" Portfolio ")];
      },
      proxy: true
    }, {
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mx-auto px-12px",
          staticStyle: {
            "max-width": "1480px"
          }
        }, [_c('v-tabs-items', {
          attrs: {
            "touchless": ""
          },
          model: {
            value: _vm.tab,
            callback: function callback($$v) {
              _vm.tab = $$v;
            },
            expression: "tab"
          }
        }, [_c('v-tab-item', {
          attrs: {
            "value": "rmfarm-high-tab",
            "transition": "fade-transition",
            "reverse-transition": "fade-transition"
          }
        }, [_c('rmfarm-high-slide')], 1), _c('v-tab-item', {
          attrs: {
            "value": "rmfarm-basic-tab",
            "transition": "fade-transition",
            "reverse-transition": "fade-transition"
          }
        }, [_c('rmfarm-basic-slide')], 1), _c('v-tab-item', {
          attrs: {
            "value": "rmfarm-entry-tab",
            "transition": "fade-transition",
            "reverse-transition": "fade-transition"
          }
        }, [_c('rmfarm-entry-slide')], 1)], 1)], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "tabs-wrap"
  }, [_c('v-tabs', {
    staticClass: "v-tabs--btn",
    attrs: {
      "hide-slider": "",
      "show-arrows": "",
      "centered": "",
      "center-active": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('u-tab', {
    attrs: {
      "to": "#rmfarm-high-tab",
      "id": "rmfarm-high-tab"
    }
  }, [_vm._v("RMFarm Premium")]), _c('u-tab', {
    attrs: {
      "to": "#rmfarm-basic-tab",
      "id": "rmfarm-basic-tab"
    }
  }, [_vm._v("RMFarm Basic")]), _c('u-tab', {
    attrs: {
      "to": "#rmfarm-entry-tab",
      "id": "rmfarm-entry-tab"
    }
  }, [_vm._v("RMFarm Entry-level")])], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }